import { render, staticRenderFns } from "./NewsCategoryInfo.vue?vue&type=template&id=14d387de&"
import script from "./NewsCategoryInfo.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports